export default __webpack_public_path__ + "static/media/portfoliopandazen.4e702771.png";